<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>Próximo Sorteio</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding padding-horizontal">

    <ion-grid>

        <ion-row>
            <ion-col size="12" sizeMd="4">
                <ion-item lines="none" fill="outline" style="max-width: 200px;">
                    <ion-label position="stacked" required i18n=":@@modal_draft.date">Data de sorteio
                    </ion-label>
                    <ion-select class="outline" [interface]="'popover'" [value]="SelectedDraftMoment?.Id"
                        (ionChange)="OnChangeMoment($event)">
                        <ion-select-option [value]="item?.Id"
                            *ngFor="let item of SelectedCampaign?.DraftMomentList">{{item?.ProcessDate | date:
                            'dd/MM/yyyy'}}</ion-select-option>
                    </ion-select></ion-item>
            </ion-col>

        </ion-row>

        <ion-row class="ion-margin-top draft">
            <ion-col size="12" class="ion-align-content-center">
                <ion-img
                    [src]="IsDrafting ? 'assets/images/draft_animacao.gif' : 'assets/images/draft_static.png'"></ion-img>
            </ion-col>
            <ion-col size="12" class="ion-align-content-center">
                <ion-button *ngIf="!SelectedDraftMoment?.WasProcessed" [disabled]="IsDrafting" size="large" fill="solid"
                    color="light" (click)="OnStartDraft($event)" shape="round">Iniciar</ion-button>
            </ion-col>
        </ion-row>
        <ion-row class="ion-margin-top ion-margin-bottom coupons">

            <ion-col size="12">

                <ion-row>
                    <ion-col class="ion-no-padding">
                        <ion-card>
                            <ion-card-content class="ion-text-center">
                                <h2>{{SelectedDraftMoment?.TotalAssignedCouponQuantity||0}}</h2>
                                <p>Cupões Registados</p>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                    <ion-col class="ion-no-padding">
                        <ion-card>
                            <ion-card-content class="ion-text-center">
                                <h2>{{SelectedDraftMoment?.TotalAssignedUsersQuantity||0}}</h2>
                                <p>Utilizadores únicos</p>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-margin-top ion-justify-content-center" style="padding:0 8px">

                    <ion-item class="full" *ngFor="let item of AwardsData">
                        <ion-label>
                            <ion-grid class="table-coupons">
                                <ion-row>
                                    <ion-col>
                                        <h2>Cupão</h2>
                                        <p><b>{{item?.Code}}</b></p>
                                    </ion-col>
                                    <ion-col>
                                        <h2>Data</h2>
                                        <p><b>{{(item?.CreateDate|date:'dd/MM/yyyy')}}</b></p>
                                    </ion-col>
                                    <ion-col>
                                        <h2>Nome</h2>
                                        <p><b>{{item?.AssignedUser?.Name||'--'}}</b> |
                                            {{item?.AssignedUser?.VatNumber||'--'}}</p>
                                    </ion-col>
                                    <ion-col class="flex-justify-end buttons-size-3">

                                        <ion-button fill="clear" size="small" (click)="OnView($event, item)">
                                            <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
                                        </ion-button>

                                        <ion-button fill="clear" size="small" (click)="OnView($event, item)">
                                            <ion-icon name="link-outline" slot="icon-only"></ion-icon>
                                        </ion-button>

                                        <ion-button fill="clear" size="small" (click)="OnView($event, item)">
                                            <ion-icon name="gift-outline" slot="icon-only"></ion-icon>
                                        </ion-button>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-label>
                    </ion-item>

                    <no-items description="sem prémios" *ngIf="AwardsData?.length==0"></no-items>

                </ion-row>
            </ion-col>

        </ion-row>

    </ion-grid>
    
</ion-content>